import React from 'react';
import { Layout } from '../components/Layout';
import { SEO } from '../components/SEO';
import { Mail, Shield } from 'lucide-react';
export function PrivacyPolicyPage() {
  return <Layout data-id="element-1809">
      <SEO title="Politique de Confidentialité" description="Politique de confidentialité de l'ADCC Bénin. Découvrez comment nous collectons, utilisons et protégeons vos données personnelles." keywords="politique de confidentialité, ADCC Bénin, protection données personnelles, RGPD" url="https://adcc.africa/privacy-policy" data-id="element-1810" />

      {/* Header */}
      <div className="bg-[#2C3E50] text-white py-16" data-id="element-1811">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1812">
          <div className="flex justify-center mb-4" data-id="element-1813">
            <Shield className="w-12 h-12 text-[#1E88E5]" data-id="element-1814" />
          </div>
          <h1 className="text-4xl font-bold mb-4" data-id="element-1815">
            Politique de Confidentialité
          </h1>
          <p className="text-gray-300" data-id="element-1816">ADCC Africa</p>
        </div>
      </div>

      {/* Content */}
      <section className="py-16 bg-white" data-id="element-1817">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1818">
          <p className="text-sm text-gray-500 mb-10" data-id="element-1819">
            Dernière mise à jour : 2026
          </p>

          <p className="text-gray-700 leading-relaxed mb-10" data-id="element-1820">
            ADCC Africa (« nous », « notre », « nos ») collecte et traite les
            données personnelles soumises via les formulaires de ce site web.
          </p>

          {/* Data we collect */}
          <div className="mb-10" data-id="element-1821">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1822">
              Données collectées
            </h2>
            <ul className="space-y-2 text-gray-700" data-id="element-1823">
              <li className="flex items-start gap-2" data-id="element-1824">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1825">●</span>
                <span data-id="element-1826">Nom</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1827">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1828">●</span>
                <span data-id="element-1829">Adresse email</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1830">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1831">●</span>
                <span data-id="element-1832">Numéro de téléphone</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1833">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1834">●</span>
                <span data-id="element-1835">Contenu des messages</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1836">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1837">●</span>
                <span data-id="element-1838">Données techniques (adresse IP, navigateur)</span>
              </li>
            </ul>
          </div>

          {/* Purpose */}
          <div className="mb-10" data-id="element-1839">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1840">Finalité</h2>
            <p className="text-gray-700 mb-3" data-id="element-1841">
              Nous utilisons ces données pour :
            </p>
            <ul className="space-y-2 text-gray-700" data-id="element-1842">
              <li className="flex items-start gap-2" data-id="element-1843">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1844">●</span>
                <span data-id="element-1845">Répondre aux demandes</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1846">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1847">●</span>
                <span data-id="element-1848">Fournir les services demandés</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1849">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1850">●</span>
                <span data-id="element-1851">Gérer les relations professionnelles</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1852">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1853">●</span>
                <span data-id="element-1854">Améliorer notre site web</span>
              </li>
            </ul>
          </div>

          {/* Legal basis */}
          <div className="mb-10" data-id="element-1855">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1856">
              Base légale
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-1857">
              Les données sont traitées sur la base du consentement de
              l'utilisateur et de l'intérêt légitime de l'organisation.
            </p>
          </div>

          {/* Data sharing */}
          <div className="mb-10" data-id="element-1858">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1859">
              Partage des données
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-1860">
              Nous ne vendons pas de données personnelles. Les données peuvent
              être traitées par des prestataires de confiance (hébergement,
              email, analytics, outils de formulaires) uniquement à des fins
              opérationnelles.
            </p>
          </div>

          {/* Data storage */}
          <div className="mb-10" data-id="element-1861">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1862">
              Stockage des données
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-1863">
              Les données sont stockées de manière sécurisée et conservées
              uniquement le temps nécessaire aux obligations professionnelles ou
              légales.
            </p>
          </div>

          {/* User rights */}
          <div className="mb-10" data-id="element-1864">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1865">
              Droits des utilisateurs
            </h2>
            <p className="text-gray-700 mb-3" data-id="element-1866">Vous pouvez demander :</p>
            <ul className="space-y-2 text-gray-700" data-id="element-1867">
              <li className="flex items-start gap-2" data-id="element-1868">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1869">●</span>
                <span data-id="element-1870">L'accès à vos données</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1871">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1872">●</span>
                <span data-id="element-1873">La correction de vos données</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1874">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1875">●</span>
                <span data-id="element-1876">La suppression de vos données</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1877">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1878">●</span>
                <span data-id="element-1879">Le retrait de votre consentement</span>
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-2 text-gray-700" data-id="element-1880">
              <Mail className="w-4 h-4 text-[#1E88E5]" data-id="element-1881" />
              <span data-id="element-1882">
                Contact :{' '}
                <a href="mailto:contact@adcc.africa" className="text-[#1E88E5] hover:underline" data-id="element-1883">
                  contact@adcc.africa
                </a>
              </span>
            </div>
          </div>

          {/* Cookies */}
          <div className="mb-10" data-id="element-1884">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1885">Cookies</h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-1886">
              Ce site web peut utiliser des cookies à des fins d'analyse et de
              fonctionnalité.
            </p>
          </div>

          {/* Contact */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-1887">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1888">Contact</h2>
            <p className="text-gray-700" data-id="element-1889">ADCC Africa</p>
            <p className="text-gray-700 flex items-center gap-2 mt-2" data-id="element-1890">
              <Mail className="w-4 h-4 text-[#1E88E5]" data-id="element-1891" />
              <a href="mailto:contact@adcc.africa" className="text-[#1E88E5] hover:underline" data-id="element-1892">
                contact@adcc.africa
              </a>
            </p>
            <p className="text-gray-700 mt-2" data-id="element-1893">
              Site web :{' '}
              <a href="https://www.adcc.africa" className="text-[#1E88E5] hover:underline" data-id="element-1894">
                https://www.adcc.africa
              </a>
            </p>
          </div>
        </div>
      </section>
    </Layout>;
}